import { useCallback } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useClientsContext } from '../context';
import { generateQueryKey, QueryKeys, QueryType } from '../utils/generateQueryKey';
export const useContactCalendarOAuth = function (authToken) {
  if (authToken === void 0) {
    authToken = null;
  }
  const {
    calendarOAuthClient
  } = useClientsContext();
  const queryClient = useQueryClient();
  const {
    data,
    isLoading,
    error,
    refetch: refetchConnectionStatus
  } = useQuery({
    queryKey: generateQueryKey(QueryKeys.CONTACT_CALENDAR_OAUTH, QueryType.GET, 'status'),
    queryFn: () => calendarOAuthClient.getContactCalendarConnectionStatus(authToken),
    enabled: !!authToken
  });
  const onRevokeTokenSuccess = useCallback(() => {
    queryClient.invalidateQueries(generateQueryKey(QueryKeys.CONTACT_CALENDAR_OAUTH, QueryType.GET, 'status'));
  }, [queryClient]);
  const {
    mutateAsync: revokeToken,
    isLoading: isRevoking
  } = useMutation({
    mutationKey: generateQueryKey(QueryKeys.CONTACT_CALENDAR_OAUTH, QueryType.DELETE),
    mutationFn: () => calendarOAuthClient.revokeTokenForClient(authToken),
    onSuccess: onRevokeTokenSuccess
  });
  return {
    isCalendarConnected: (data == null ? void 0 : data.isConnected) ?? null,
    isLoading,
    isRevoking,
    error,
    refetchConnectionStatus,
    revokeToken
  };
};
//# sourceMappingURL=useContactCalendarOAuth.js.map